import theme from "@theme/";
import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const AssignUserDropdown = (props) => {
  const {
    onChange,
    name,
    defaultValue,
    disabledDropdown,
    width = "90%",
    projectId,
    type,
    roleId,
  } = props;

  const [template, setTemplate] = useState();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const getAllOptionData = async () => {
    try {
      let endpoints =
        roleId == 4
          ? `/v1/addressbook/${currentProject.id}/${0}?excluderoleIds=1,2,3,4
            `
          : `/v1/addressbook/${
              currentProject.id
            }/${0}?excluderoleIds=${roleId}`;

      const response = await apiGet(endpoints);

      const projectOptions = response.data.map((template) => ({
        id: template.id,
        label: template.fullName,
      }));
      setTemplate(projectOptions);
    } catch (error) {
      console.error("Error fetching projects", error);
    }
  };

  useEffect(() => {
    getAllOptionData();
  }, [roleId]);

  const handleDropdownChange = (value) => {
    // Find the corresponding label for the selected value
    const selectedOption = template.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";

    // Pass both value and label to the onChange handler
    onChange(name, value, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select User"
      options={template}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width={width}
      dropdowType={"AssignUserDropdown"}
      disabledDropdown={disabledDropdown}
      theme={{ colors: { bordertask: theme.colors.themeColor } }}
    />
  );
};

export default AssignUserDropdown;
